import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=2e960fd0&"
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Logout.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/auth/Logout.vue
// module id = null
// module chunks = 